import React from 'react';
import styled from 'styled-components';
import type { BannerLayout } from '../../@types/Content';

interface MaybeLinkProps {
  children: React.ReactNode;
  ctaUrl?: string;
  fullWidth: boolean;
  ariaLabel: string;
  bannerLayout: BannerLayout;
}

export const MaybeLink: React.FC<MaybeLinkProps> = ({
  children,
  ctaUrl,
  fullWidth,
  ariaLabel,
  bannerLayout,
}: MaybeLinkProps) => {
  return ctaUrl && bannerLayout === 'imageOnly' ? (
    <CustomLink
      data-testid="Banner__link"
      href={ctaUrl}
      target="_self"
      fullWidth={fullWidth}
      aria-label={ariaLabel}
    >
      {children}
    </CustomLink>
  ) : (
    children
  );
};

const CustomLink = styled.a<{ fullWidth: boolean }>`
  ${(props) => props.fullWidth && 'width: 100%;'}
  text-decoration: none;
  height: 100%;
  min-height: 100px;
`;
